<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M23.5 11.4916C23.5 5.14484 18.3511 0 12 0C5.6489 0 0.5 5.14484 0.5 11.4916C0.5 14.1032 1.37303 16.5105 2.84188 18.4403C2.10077 17.0179 1.68043 15.3792 1.68043 13.5961C1.68043 7.69114 6.2668 3.34315 12 3.34315C17.7332 3.34315 22.3196 7.69114 22.3196 13.5961C22.3196 15.3789 21.8995 17.0179 21.1581 18.4403C22.627 16.5102 23.5 14.1032 23.5 11.4916ZM19.0561 13.5961C19.0561 9.36598 16.1455 6.19289 12 6.19289C7.8545 6.19289 4.94356 9.36598 4.94356 13.5961C4.94356 17.8269 7.8545 21 12 21C16.1455 21 19.0561 17.8269 19.0561 13.5961Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgSNMMIConnect',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>